<template>
  <div>
    <v-container fluid class="pa-4">
      <div class="d-flex">
        <span class="headline primary--text font-weight-medium">
          <v-icon class="primary--text" left>mdi-calendar-clock</v-icon>Voyage
          Planning
        </span>
        <v-spacer></v-spacer>
        <!-- Dummy View Switch -->
        <v-switch v-model="testView" label="Toggle Test View"></v-switch>
      </div>
      <!-- Dummy Requests For DEMO - Delete Later -->
      <div v-if="testView">
        <p>
          Dummy Data for VoyageNo: ABZ/284/20 and Vessel Name: STANDARD VIKING
        </p>
        <v-container class="my-6">
          <VoyagePlanRequestCard
            v-for="request in dummyData"
            :key="request.id"
            :request="request"
          />
        </v-container>
      </div>
      <!-- End of Dummy View -->
      <div v-if="!dataLoading">
        <v-container
          class="my-6"
          v-if="planningRequests && planningRequests.length > 0"
        >
          <!-- requests -->
          <VoyagePlanRequestCard
            v-for="request in planningRequests"
            :key="request.id"
            :request="request"
          />
        </v-container>
        <v-row
          v-else-if="planningRequests && planningRequests.length === 0"
          justify="center"
        >
          <v-alert outlined type="info" color="primary">
            No Planning Requests found for voyage
          </v-alert>
        </v-row>
        <v-row v-else-if="!planningRequests" justify="center">
          <v-alert outlined type="error">
            Could not connect to external system
          </v-alert>
        </v-row>
      </div>
      <v-progress-circular
        v-else
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import VoyagePlanRequestCard from './VoyagePlanRequestCard.vue';
import dummyRequestData from '../../dummy_data/foresightRequestsResponseDummy.json';

export default {
  name: 'VoyagePlan',
  components: {
    VoyagePlanRequestCard,
  },
  data() {
    return {
      dummyData: dummyRequestData,
      testView: false,
    };
  },
  props: {
    planningRequests: Array,
    dataLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
</style>
